import React, { useState } from "react";
import Marketplace from "./SuperkartTheme/Marketplace";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";

const SuperkartThemePageRoute = ({themeColor}) => {
  const { pageId } = useParams();
  const [activeTab, setActiveTab] = useState("category 1");

  const tabs = [
    "category 1",
    "category 2",
    "category 3",
    "category 4",
    "category 5",
    "category 6",
    "category 7",
  ];

  return (
    <>
      <div className="border-top border-bottom">
        {pageId === "checkout" ? (
          <div className="text-center fw-bold fs-12 py-1">
            {pageId === "checkout" ? "Checkout" : " "}
          </div>
        ) : (
          <Container>
            <div className="hstack flex-wrap">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`tabItem border-end ${
                    activeTab === tab && "tabItemActive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>
          </Container>
        )}
      </div>
      <Marketplace themeColor={themeColor} />
      {/* ) : pageId === "account" ? (
        <UserAccountDetail />
      ) : pageId === "cart" ? (
        <CartFullPage storeName={storeName} />
      ) : pageId === "checkout" ? (
        <CheckoutFullPage />
      ) : (
        ""
      )} */}
    </>
  );
};

export default SuperkartThemePageRoute;
